import type * as Types from '../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ApplyWebsiteTemplateSettingsMutationVariables = Types.Exact<{
  payload: Types.ApplyWebSiteTemplateSettingsPayload;
}>;

export type ApplyWebsiteTemplateSettingsMutation = {
  __typename?: 'Mutation';
  applyWebSiteTemplateSettings: {
    __typename?: 'EventDesign';
    id: string;
    activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; schemaURL: string; websiteLayout: string; dataJSON: any; id: string } | null;
  };
};

export const ApplyWebsiteTemplateSettingsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplyWebsiteTemplateSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplyWebSiteTemplateSettingsPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyWebSiteTemplateSettings' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApplyWebsiteTemplateSettingsMutationFn = Apollo.MutationFunction<ApplyWebsiteTemplateSettingsMutation, ApplyWebsiteTemplateSettingsMutationVariables>;

/**
 * __useApplyWebsiteTemplateSettingsMutation__
 *
 * To run a mutation, you first call `useApplyWebsiteTemplateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyWebsiteTemplateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyWebsiteTemplateSettingsMutation, { data, loading, error }] = useApplyWebsiteTemplateSettingsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useApplyWebsiteTemplateSettingsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyWebsiteTemplateSettingsMutation, ApplyWebsiteTemplateSettingsMutationVariables>,
) {
  return ApolloReactHooks.useMutation<ApplyWebsiteTemplateSettingsMutation, ApplyWebsiteTemplateSettingsMutationVariables>(ApplyWebsiteTemplateSettingsDocument, baseOptions);
}
export type ApplyWebsiteTemplateSettingsMutationHookResult = ReturnType<typeof useApplyWebsiteTemplateSettingsMutation>;
export type ApplyWebsiteTemplateSettingsMutationResult = Apollo.MutationResult<ApplyWebsiteTemplateSettingsMutation>;
export type ApplyWebsiteTemplateSettingsMutationOptions = Apollo.BaseMutationOptions<ApplyWebsiteTemplateSettingsMutation, ApplyWebsiteTemplateSettingsMutationVariables>;
